export const api = process.env.NODE_ENV == "development" ? "http://localhost:8080" : "https://api.studyable.app";